import React, { useEffect, useCallback, useRef, useState } from "react";
import "./ArCustomerPaymentLedger.css";
import { Select, DatePicker, Form, Table, Button, Input } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { getRegion } from "../../redux/actions/region.action";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { getGender } from "../../redux/actions/gender.action";
import { getAllCompany } from "../../redux/actions/companyAccess";
import { getAllScmBrand } from "../../redux/actions/scmBrand.action";
import { getCustomerType } from "../../redux/actions/customerType.action";
import { loadCustomers } from "../../redux/actions/customerForm";
import { getArCustomerPaymentReport } from "../../redux/actions/customerPayment.action";
import logo from "../../assets/images/logo-black.svg";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import csv from "../../assets/images/csv.png";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import { TabTitle } from "../../utils/GeneralFunction";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from "exceljs";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { SearchOutlined, FilterFilled } from "@ant-design/icons";

const { Option } = Select;
const dateFormatList = ["MM/DD/YYYY"];

const ArCustomerPaymentLedger = ({ token }) => {
  TabTitle("Ar Customer Ledger");
  const userName = ReadCookie("name");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const focusInput = useRef(null);
  const tableRef = useRef(null);
  const [select, setSelect] = useState("All");
  const [loader, setLoader] = useState(false);
  const [customerList, setCutomerList] = useState([]);
  const [customerId, setCutomerId] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const {
    gender,
    region,
    companyAll,
    scmBrand,
    customerForms,
    getBussinessDashboardReducer,
    arCustomerPayment,
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const [customer, setCustomer] = useState("All");
  const { submited } = useParams();

  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(
      loadCustomers(
        token,
        null,
        null,
        null,
        null,
        null,
        val,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      )
    ).then((res) => {
      if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
        setCustomer(res?.payload?.data);
      }
    });
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);
  let rbalance = 0;

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let customer_id = query.get("customer_id");
  let customer_name = query.get("customer_name");

  useEffect(() => {
    let values = {
      customer_id: customer_id,
      from_date: "01-01-2010",
      to_date: moment().endOf('year'),
      status: "U",
      customer_name: customer_name,
    };

    form.setFieldsValue({
      customer_id: values.customer_name,
      from_date: moment(values.from_date),
      to_date: moment(values.to_date),
      status: "U",
    });
    if (customer_id) {
      setLoader(true);
      dispatch(getArCustomerPaymentReport(token, values)).then((res) => {
        let filterData = res?.payload?.data;
        //  && res?.payload?.data.filter((elem) => {
        //   return elem.invoice_header_id != "0";
        // })

        let filterZeroId = res?.payload?.data;
        //  && res?.payload?.data.filter((elem) => {
        //   return elem.invoice_header_id == "0";
        // })
        setCutomerId(filterZeroId);
        setCutomerList(filterData);
        setLoader(false);
        downloadExcelFileData(filterData);
      });
    }
  }, [customer_id]);

  const onFinish = async (e) => {
    setLoader(true);
    await form.validateFields().then((values) => {
      dispatch(getArCustomerPaymentReport(token, values)).then((res) => {
        let filterData = res?.payload?.data;
        //  && res?.payload?.data.filter((elem) => {
        //   return elem.invoice_header_id != "0";
        // })

        let filterZeroId = res?.payload?.data;
        //  && res?.payload?.data.filter((elem) => {
        //   return elem.invoice_header_id == "0";
        // })

        setCutomerId(filterZeroId);
        setCutomerList(filterData);
        setLoader(false);
        downloadExcelFileData(filterData);
      });
    });
  };

  useEffect(() => {
    dispatch(getRegion(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getPaymentTerm(token, menuId));
    dispatch(getAllCompany(token));
    dispatch(getAllScmBrand(token));
    dispatch(getCustomerType(token));
  }, [dispatch, menuId, token]);

  const handlePrint = () => {
    window.print();
  };

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          TransType: v.transtype,
          "Invoice#": v.invoice_header_no,
          "Invoice Date": moment(v.invoice_date).format("MM-DD-YYYY"),
          "Trans Number": v.payment_header_no,
          "PO Number": v.po_number,
          "Invoice Amount": `$ ${v.invoice_amount}`,
          Return: `$ ${v.note_amount}`,
          Payment: `$ ${v.amount_paid}`,
          "Refund Amount": `$ ${v.refund_amount}`,
          "Memo Amount": `$ ${v.credit_memo_amount}`,
          "Note Apply": `$ ${v.credit_note_apply}`,
          "Memo Apply": `$ ${v.credit_memo_apply}`,
          "Unapplied Amount": `$ ${v.unapplied_amount}`,
        };
      })
    );
  }

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");

    worksheet.columns = [
      { header: "TransType", key: "transtype", width: 30 },
      { header: "Invoice#", key: "invoice_header_no", width: 30 },
      { header: "Invoice Date", key: "invoice_date", width: 30 },
      { header: "TransNo", key: "payment_header_no", width: 30 },
      { header: "PO Number", key: "po_number", width: 15 },
      { header: "Invoice Amount", key: "invoice_amount", width: 15 },
      { header: "Return", key: "note_amount", width: 15 },
      { header: "Payment", key: "amount_paid", width: 15 },
      { header: "Refund Amount", key: "refund_amount", width: 15 },
      { header: "Memo Amount", key: "credit_memo_amount", width: 15 },
      { header: "Note Apply", key: "credit_note_apply", width: 15 },
      { header: "Memo Apply", key: "credit_memo_apply", width: 15 },
      { header: "Unapplied Amount", key: "unapplied_amount", width: 15 },
    ];

    worksheet.getColumn("invoice_date").numFmt = "mm-dd-yyyy";

    let filterData = arCustomerPayment?.payload?.data;
    //  && arCustomerPayment?.payload?.data.filter((elem) => {
    //   return elem.invoice_header_id != "0";
    // })

    let totalInvoiceAmount = 0;
    let totalCreditNote = 0;
    let totalPayment = 0;
    let totalRefund = 0;
    let totalMemo = 0;
    let totalNote = 0;
    let totalMemoApply = 0;
    let totalNoteApply = 0;
    let totalUnApplied = 0;

    filterData.forEach((item) => {
      const row = worksheet.addRow({
        transtype: item.transtype,
        invoice_header_no: item.invoice_header_no,
        invoice_date: item.invoice_date ? new Date(item.invoice_date) : null,
        payment_header_no: item.payment_header_no,
        po_number: item.po_number,
        invoice_amount: `$ ${numeral(item.invoice_amount).format("0,00.00")}`,
        note_amount: `$ ${numeral(item.note_amount).format("0,00.00")}`,
        amount_paid: `$ ${numeral(item.amount_paid).format("0,00.00")}`,
        refund_amount: `$ ${numeral(item.refund_amount).format("0,00.00")}`,
        credit_memo_amount: `$ ${numeral(item.credit_memo_amount).format("0,00.00")}`,
        credit_note_apply: `$ ${numeral(item.credit_note_apply).format("0,00.00")}`,
        credit_memo_apply: `$ ${numeral(item.credit_memo_apply).format("0,00.00")}`,
        unapplied_amount: `$ ${numeral(item.unapplied_amount).format("0,00.00")}`,
      });

      row.getCell("invoice_date").numFmt = "mm-dd-yyyy";

      totalInvoiceAmount += Number(item.invoice_amount);
      totalCreditNote += Number(item.note_amount);
      totalPayment += Number(item.amount_paid);

      totalRefund += Number(item.refund_amount);
      totalMemo += Number(item.credit_memo_amount);
      totalNote += Number(item.credit_note_amount);
      totalNoteApply += Number(item.credit_note_apply);
      totalMemoApply += Number(item.credit_memo_apply);
      totalUnApplied += Number(item.unapplied_amount);
    });

    worksheet.addRow({
      invoice_amount: totalInvoiceAmount,
      note_amount: totalCreditNote,
      amount_paid: totalPayment,
      refund_amount: totalRefund,
      credit_memo_amount: totalMemo,
      credit_note_amount: totalNote,
      credit_note_apply: totalNoteApply,
      credit_memo_apply: totalMemoApply,
      unapplied_amount: totalUnApplied,
    });

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const filename = "Ar-Customer-Payment-ledger.xlsx";

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    } catch (error) {
      console.error(error);
    }
  };

  function generatePDF() {
    var doc = new jsPDF();

    var columns = [
      "TransType",
      "Invoice#",
      "Invoice Date",
      "TransNo",
      "PO Number",
      "Invoice Amount",
      "Return",
      "Payment",
      "Refund Amount",
      "Memo Amount",
      "Note Apply",
      "Memo Apply",
      "Unapplied Amount",
    ];

    var rows = [];

    var customerName =
      arCustomerPayment?.payload?.data[0]?.customer_name || "Unknown Customer";

    doc.setFontSize(10);
    doc.text(`Customer Name: ${customerName}`, 15, 10);

    var yOffset = 15;

    let filteredData = arCustomerPayment?.payload?.data;
    // ?.filter((elem) => elem.invoice_header_id != "0") || [];

    filteredData.forEach((item) => {
      var row = [
        item.transtype,
        item.invoice_header_no,
        moment(item.invoice_date).format("MM-DD-YYYY"),
        item.payment_header_no,
        item.po_number,
        "$" + numeral(item.invoice_amount).format("0,00.00"),
        "$" + numeral(item.note_amount).format("0,00.00"),
        "$" + numeral(item.amount_paid).format("0,00.00"),
        "$" + numeral(item.refund_amount).format("0,00.00"),
        "$" + numeral(item.credit_memo_amount).format("0,00.00"),
        "$" + numeral(item.credit_note_apply).format("0,00.00"),
        "$" + numeral(item.credit_memo_apply).format("0,00.00"),
        "$" + numeral(item.unapplied_amount).format("0,00.00"),
      ];
      rows.push(row);
    });

    // Totals
    const totalInvoiceAmount = filteredData.reduce(
      (acc, item) => acc + Number(item.invoice_amount || 0),
      0
    );
    const totalCreditNote = filteredData.reduce(
      (acc, item) => acc + Number(item.note_amount || 0),
      0
    );
    const totalPayment = filteredData.reduce(
      (acc, item) => acc + Number(item.amount_paid || 0),
      0
    );
    const totalRefund = filteredData.reduce(
      (acc, item) => acc + Number(item.refund_amount || 0),
      0
    );
    const totalMemo = filteredData.reduce(
      (acc, item) => acc + Number(item.credit_memo_amount || 0),
      0
    );
    const totalNoteApply = filteredData.reduce(
      (acc, item) => acc + Number(item.credit_note_apply || 0),
      0
    );
    const totalMemoApply = filteredData.reduce(
      (acc, item) => acc + Number(item.credit_memo_apply || 0),
      0
    );
    const totalUnapplied = filteredData.reduce(
      (acc, item) => acc + Number(item.unapplied_amount || 0),
      0
    );

    rows.push([
      " ",
      " ",
      " ",
      " ",
      "Total:",
      "$" + totalInvoiceAmount.toLocaleString("en-US"),
      "$" + totalCreditNote.toLocaleString("en-US"),
      "$" + totalPayment.toLocaleString("en-US"),
      "$" + totalRefund.toLocaleString("en-US"),
      "$" + totalMemo.toLocaleString("en-US"),
      "$" + totalNoteApply.toLocaleString("en-US"),
      "$" + totalMemoApply.toLocaleString("en-US"),
      "$" + totalUnapplied.toLocaleString("en-US"),
    ]);

    // Render PDF Table
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: yOffset + 5,
      styles: { fontSize: 6 },
    });

    doc.save("Ar-Customer-Payment-Ledger.pdf");
  }

  const column = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 40,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "TransType",
      dataIndex: "transtype",
      key: "transtype",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search TransType"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) =>
        record.transtype.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Invoice#",
      dataIndex: "invoice_header_no",
      key: "invoice_header_no",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search Invoice#"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) =>
        record.invoice_header_no
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "invoice_date",
      render: (text, record) => {
        return moment(record.invoice_date).format("MM-DD-YYYY");
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search Invoice Date"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) =>
        moment(record.invoice_date)
          .format("MM-DD-YYYY")
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: "TransNo",
      dataIndex: "payment_header_no",
      key: "payment_header_no",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search TransNo"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) =>
        record?.payment_header_no
          ?.toString()
          ?.toLowerCase()
          ?.includes(value.toLowerCase()),
    },
    {
      title: "PO Number",
      dataIndex: "po_number",
      key: "po_number",
      width: 150,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search PO Number"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) =>
        record.po_number.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Invoice Amount",
      dataIndex: "invoice_amount",
      key: "invoice_amount",
      render: (text, record) => {
        return "$" + numeral(record.invoice_amount).format("0,00.00");
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search Invoice Amount"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        // Remove commas and parse the raw numeric value
        const rawAmount = record.invoice_amount;
        const formattedValue = value.replace(/,/g, ""); // Remove commas from search input
        return rawAmount.toString().includes(formattedValue); // Compare with raw number
      },
    },
    {
      title: "Return",
      dataIndex: "note_amount",
      key: "note_amount",
      render: (text, record) => {
        return "$" + numeral(record.note_amount).format("0,00.00");
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search Return Amount"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        // Remove commas and parse the raw numeric value
        const rawAmount = record.note_amount;
        const formattedValue = value.replace(/,/g, ""); // Remove commas from search input
        return rawAmount.toString().includes(formattedValue); // Compare with raw number
      },
    },
    // {
    //   title: "Payment/Adjustment",
    //   dataIndex: "amount_paid",
    //   key: "amount_paid",
    //     render: (text, record) => (
    //       <Link
    //       style={{ padding: "10px", textDecoration: "none" }}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       to={{ pathname: `/customer-payment-report`, search: `?invoice_id=${record?.invoice_header_id}` }}
    //     >
    //         {"$" + numeral(record.amount_paid).format("0,00.00")}
    //       </Link>
    //     )
    // },
    {
      title: "Payment",
      dataIndex: "amount_paid",
      key: "amount_paid",
      render: (text, record) => {
        return "$" + numeral(record.amount_paid).format("0,00.00");
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search Payment"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        // Remove commas and parse the raw numeric value
        const rawAmount = record.amount_paid;
        const formattedValue = value.replace(/,/g, ""); // Remove commas from search input
        return rawAmount.toString().includes(formattedValue); // Compare with raw number
      },
    },
    {
      title: "Refund Amount",
      dataIndex: "refund_amount",
      key: "refund_amount",
      render: (text, record) => (
        <Link
          style={{ padding: "10px", textDecoration: "none" }}
          target="_blank"
          rel="noopener noreferrer"
          to={{
            pathname: `/customer-refund-report`,
            search: `?invoice_id=${record?.invoice_header_id}`,
          }}
        >
          {"$" + numeral(record.refund_amount).format("0,00.00")}
        </Link>
      ),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search Refund Amount"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        // Remove commas and parse the raw numeric value
        const rawAmount = record.refund_amount;
        const formattedValue = value.replace(/,/g, ""); // Remove commas from search input
        return rawAmount.toString().includes(formattedValue); // Compare with raw number
      },
    },
    {
      title: "Memo Amount",
      dataIndex: "credit_memo_amount",
      key: "credit_memo_amount",
      render: (text, record) => {
        return "$" + numeral(record.credit_memo_amount).format("0,00.00");
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search Memo Amount"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        // Remove commas and parse the raw numeric value
        const rawAmount = record.credit_memo_amount;
        const formattedValue = value.replace(/,/g, ""); // Remove commas from search input
        return rawAmount.toString().includes(formattedValue); // Compare with raw number
      },
    },
    {
      title: "Note Apply",
      dataIndex: "credit_note_apply",
      key: "credit_note_apply",
      render: (text, record) => {
        return "$" + numeral(record.credit_note_apply).format("0,00.00");
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search Note Apply"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        // Remove commas and parse the raw numeric value
        const rawAmount = record.credit_note_apply;
        const formattedValue = value.replace(/,/g, ""); // Remove commas from search input
        return rawAmount.toString().includes(formattedValue); // Compare with raw number
      },
    },
    {
      title: "Memo Apply",
      dataIndex: "credit_memo_apply",
      key: "credit_memo_apply",
      render: (text, record) => {
        return "$" + numeral(record.credit_memo_apply).format("0,00.00");
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search Memo Apply"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        // Remove commas and parse the raw numeric value
        const rawAmount = record.credit_memo_apply;
        const formattedValue = value.replace(/,/g, ""); // Remove commas from search input
        return rawAmount.toString().includes(formattedValue); // Compare with raw number
      },
    },
    {
      title: "Unapplied Amount",
      dataIndex: "unapplied_amount",
      key: "unapplied_amount",
      render: (text, record) => {
        return "$" + numeral(record.unapplied_amount).format("0,00.00");
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <>
          <Input
            autoFocus
            allowClear
            className="pop-search-gen pop-170"
            placeholder="Search Unapplied Amount"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
            onBlur={() => confirm()}
          />
        </>
      ),
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        // Remove commas and parse the raw numeric value
        const rawAmount = record.unapplied_amount;
        const formattedValue = value.replace(/,/g, ""); // Remove commas from search input
        return rawAmount.toString().includes(formattedValue); // Compare with raw number
      },
    },
  ];

  const total_invoice_amount = customerList.reduce(
    (acc, item, index) => acc + parseFloat(item.invoice_amount),
    0
  );
  const total_note_amount = customerList.reduce(
    (acc, item, index) => acc + parseFloat(item.note_amount),
    0
  );
  const total_payment_us = customerList.reduce(
    (acc, item, index) => acc + parseFloat(item.amount_paid),
    0
  );

  const total_refund_amount = customerList.reduce(
    (acc, item, index) => acc + parseFloat(item.refund_amount),
    0
  );

  const total_credit_memo_amount = customerList.reduce(
    (acc, item, index) => acc + parseFloat(item.credit_memo_amount),
    0
  );
  const total_credit_note_apply = customerList.reduce(
    (acc, item, index) => acc + parseFloat(item.credit_note_apply),
    0
  );
  const total_credit_memo_apply = customerList.reduce(
    (acc, item, index) => acc + parseFloat(item.credit_memo_apply),
    0
  );
  const total_unapplied_amount = customerList.reduce(
    (acc, item, index) => acc + parseFloat(item.unapplied_amount),
    0
  );

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className="report-wrapper-main header_class business_class ledger_print">
            <div className="row business_header justify-content-between pb-2 ledger_print">
              <div className="col-3 d-flex align-items-start  box-space">
                <div className="logobrand">
                  <img id="ImgLogo" alt="logo" src={logo} />
                </div>
              </div>

              <div className="col-6 box-space right-content-header text-right pb-0">
                <div className=" d-flex justify-content-end">
                  <div className=" d-flex printing_class mr-8">
                    <div className="print_icon printing_class">
                      <i
                        onClick={handlePrint}
                        id="Image1"
                        title="Print"
                        alt="Print"
                        src={btnPrint}
                        className="fa-solid fa-print"
                      ></i>
                    </div>
                    <div className="print_icon printing_class">
                      <CSVLink
                        filename={"Ar-Customer-Payment-ledger.csv"}
                        data={excelData}
                        onClick={() => { }}
                      >
                        <input
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={csv}
                          style={{ borderWidth: "0px", height: "14px" }}
                        />
                      </CSVLink>
                    </div>
                    <div className="print_icon printing_class">
                      <input
                        type="image"
                        name="ImgExcel"
                        alt="Export to Excel"
                        id="ImgExcel"
                        title="Export to Excel"
                        src={xlsx}
                        onClick={exportToExcel}
                        style={{ borderWidth: "0px", height: "14px" }}
                      />
                    </div>
                    <div className="print_icon printing_class">
                      <input
                        type="image"
                        name="ImgPDF"
                        alt="Export to PDF"
                        id="ImgPDF"
                        title="Export to PDF"
                        src={pdf}
                        onClick={generatePDF}
                        style={{ borderWidth: "0px", height: "18px" }}
                      />
                      {/* <button onClick={() => generatePDF()}>Generate PDF</button> */}
                    </div>
                  </div>
                  <span style={{ fontWeight: "bolder" }}>
                    Ar Customer Payment Ledger
                    <br />
                    <div className="printing_class123">
                      Rpt # 489
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            {/* Filters Table */}
            <div className="row  business_header ledger_print">
              <div className="col business_header">
                <Form form={form} name="control-hooks" onFinish={onFinish}>
                  <div className="main_form row">
                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label htmlFor="" className="labels width30">
                          From:
                        </label>
                        <div className=" w-100">
                          <Form.Item
                            className="full_date"
                            name="from_date"
                          // initialValue={moment().startOf('year')}
                          >
                            <DatePicker
                              size="small"
                              // defaultValue={moment().format("MM-DD-YYYY")}
                              format={dateFormatList}
                              className={"input-width"}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label htmlFor="" className="labels width30">
                          To:
                        </label>
                        <div className=" w-100">
                          <Form.Item
                            className="full_date"
                            name="to_date"
                            initialValue={moment().endOf("year")}
                          >
                            <DatePicker
                              size="small"
                              defaultValue={moment().format("MM-DD-YYYY")}
                              format={dateFormatList}
                              className={"input-width"}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="main_form row">
                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width30">Customer:</label>
                        <div className=" w-100">
                          <Form.Item
                            name="customer_id"
                            rules={[
                              {
                                required: true,
                                message: "Customer is Required",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              optionFilterProp="children"
                              className={"select_Inputs"}
                              loading={customerForms.loading}
                              size="small"
                              onSearch={(value) => {
                                optimizedFn(value);
                              }}
                              ref={focusInput}
                              value={customer}
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {customerForms?.payload?.data.map((item) => {
                                return (
                                  <Option key={item.customer_id}>
                                    {`${item.customer_name}`}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className=" col-6">
                      {/* <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width30">Status:</label>
                        <div className=" w-100">
                          <Form.Item
                            className=" w-100"
                            name="status"
                            initialValue={"All"}
                          >
                            <Select
                              showSearch
                              optionFilterProp="children"

                              className="select_Inputs"

                              defaultValue={
                                submited ? form.getFieldValue().status : "All"
                              }
                              size="small"

                            >
                              <Option key={"All"} value={"All"}>
                                All
                              </Option>
                              <Option key={"P"} value={"P"}>
                                Paid
                              </Option>
                              <Option key={"U"} value={"U"}>
                                Unpaid
                              </Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div> */}
                      <div>
                        <Button
                          htmlType="submit"
                          type="primary"
                          className="submit-btn-btm "
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
            {/* Render Data Table */}
          </div>
          <div
            className="table_content customer_ledger_table_content ledger_print"
            style={{ maxWidth: "1560px" }}
          >
            <div className="">
              {arCustomerPayment ? (
                arCustomerPayment?.payload?.data.length > 0 ? (
                  <div className="data_Table">
                    <div>
                      <div style={{ margin: "0 auto", paddingTop: "10px" }}>
                        <table
                          id="Table1"
                          cellPadding="3"
                          cellSpacing="0"
                          align="center"
                          className="tablestyleControls"
                          style={{ fontSize: "10px" }}
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{ width: "60px" }}
                                className="font_weight"
                              >
                                Name :
                              </td>
                              <td colSpan={2}>
                                <b>
                                  {
                                    arCustomerPayment?.payload?.data[0]
                                      .customer_name
                                  }
                                </b>
                              </td>
                              {/* <td></td> */}
                            </tr>
                            {/* <tr>
                                <td className="font_weight">
                                  Address :
                                </td>
                                <td colSpan={2}>
                                  <b>
                                    {arCustomerPayment?.payload?.data[0].address_1}
                                  </b>
                                </td>
                                <td></td>
                                <td className="font_weight">
                                  Balance :
                                </td>
                                <td colSpan={2}>
                                  <b className="font_weight">
                                    ${numeral(total_balance).format("0,00,0")}
                                  </b>
                                </td>
                              </tr> */}
                            {/* <tr>
                                <td className="no-border-btm font_weight" style={{ width: "70px" }}>
                                  City :
                                </td>
                                <td style={{ width: "263px" }}>
                                  <b>
                                    {arCustomerPayment?.payload?.data[0].city_name}
                                  </b>
                                </td>
                                <td style={{ width: "126px" }} className="font_weight">
                                  State :
                                </td>
                                <td style={{ width: "119.6px" }} >
                                  <b>
                                    {arCustomerPayment?.payload?.data[0].state_name}
                                  </b>
                                </td>
                              </tr> */}
                            {/* <tr>
                                <td className="font_weight">
                                  City :
                                </td>
                                <td>
                                  <b>
                                    {arCustomerPayment?.payload?.data[0].city_name}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight" >
                                  State :
                                </td>
                                <td style={{ width: "50px" }}>
                                  <b>
                                    {arCustomerPayment?.payload?.data[0].state_name}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight">
                                  Other Credit :
                                </td>
                                <td>
                                  <b className="font_weight">
                                    ${numeral(customerId && customerId[0]?.credit_balance).format("0,00,0")}
                                  </b>
                                </td>
                              </tr>
                              <tr>
                                <td className="font_weight">
                                  Country :
                                </td>
                                <td>
                                  <b>
                                    {arCustomerPayment?.payload?.data[0].country_name}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight">
                                  Zip Code :
                                </td>
                                <td style={{ width: "50px" }}>
                                  <b>
                                    {arCustomerPayment?.payload?.data[0].zip_code}
                                  </b>
                                </td>
                                <td className="no-border-btm font_weight">
                                  Unapplied Amount :
                                </td>
                                <td >
                                  <b className="font_weight">
                                    ${numeral(customerId && customerId[0]?.unapplied_amount).format("0,00,0")}
                                  </b>
                                </td>
                              </tr> */}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
              <Table
                className="
                
                test04 mt-3 sales_report_res_table_intransit ledger_print"
                ref={tableRef}
                size="small"
                bordered={false}
                type="company"
                headerClassName="abc"
                dataSource={customerList && customerList}
                columns={column}
                loading={arCustomerPayment.loading}
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: 100,
                  pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000],
                }}
                summary={(pageData) => {
                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell colSpan={3}>
                          {/* Other Credit : ${numeral(customerId && customerId[0]?.credit_balance).format("0,00,0")} */}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell colSpan={2}>
                          {/* Unapplied Amount : ${numeral(total_unapplied_amount).format("0,00,0")} */}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>

                        <Table.Summary.Cell>
                          <p
                            style={{ textAlign: "left", margin: "0" }}
                            className="totalquantity"
                          >
                            ${total_invoice_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p
                            style={{ textAlign: "left", margin: "0" }}
                            className="totalquantity"
                          >
                            ${total_note_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        {/* <Table.Summary.Cell>
                          <p style={{ textAlign: "left", margin: "0" }} className="totalquantity">
                            {total_memo_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell>
                          <p
                            style={{ textAlign: "left", margin: "0" }}
                            className="totalquantity"
                          >
                            ${total_payment_us.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p
                            style={{ textAlign: "left", margin: "0" }}
                            className="totalquantity"
                          >
                            ${total_refund_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p
                            style={{ textAlign: "left", margin: "0" }}
                            className="totalquantity"
                          >
                            ${total_credit_memo_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p
                            style={{ textAlign: "left", margin: "0" }}
                            className="totalquantity"
                          >
                            ${total_credit_note_apply.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p
                            style={{ textAlign: "left", margin: "0" }}
                            className="totalquantity"
                          >
                            ${total_credit_memo_apply.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p
                            style={{ textAlign: "left", margin: "0" }}
                            className="totalquantity"
                          >
                            ${total_unapplied_amount.toLocaleString("en-US")}
                          </p>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArCustomerPaymentLedger;
